
export const environment = {
  transitionTimerDelayMs: 5,
}